export function cloneBuffer(value: Buffer): Buffer {
  const length = value.length;
  const buffer = Buffer.allocUnsafe
    ? Buffer.allocUnsafe(length)
    : Buffer.from(length as any);

  value.copy(buffer);

  return buffer;
}
